import ReversedRadiusDivider from "components/common/ReversedRadiusDivider";
import { ActionBar } from "./actionbar";
import ArticlesTable from "./table";
import ArticlesModal from "./modal";

import styles from "./index.module.scss";
const ArticlesTab = () => {
  return (
    <>
      <ReversedRadiusDivider />
      <div className={styles.articles_management_container}>
        <ActionBar className="pt-10" />
        <ArticlesTable />
      </div>
      <ArticlesModal />
    </>
  );
};

export default ArticlesTab;
